import Vue from 'vue';

Vue.config.productionTip = false;
import FreeApp from "./FreeApp";
new Vue({
    render: h => h(FreeApp)
}).$mount('#free-app');
